import React, { useEffect, useRef, useState } from "react";
import { MoreVert } from "../assets/svg/AllSvg";

const Action = ({ optionList, fillClass, fillOpacity, isEnd }) => {
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);

  const toggling = () => setOpen(!open);
  useEffect(() => {
    function handler(event) {
      if (!cancelButtonRef.current?.contains(event.target)) {
        setOpen(false);
      }
    }
    window.addEventListener("click", handler);
    return () => window.removeEventListener("click", handler);
  }, []);
  return (
    <>
      <div
        className={`relative cursor-pointer py-2 px-3 ${
          isEnd && "flex justify-end"
        }`}
        ref={cancelButtonRef}
        onClick={() => toggling()}
      >
        <MoreVert fillClass={fillClass} fillOpacity={fillOpacity} />
        {open && (
          <>
            <ul className="absolute top-[calc(100%+0.4rem)] lg:min-w-[10rem] min-w-32 right-0 bg-white shadow-md rounded-lg overflow-auto lg:text-base sm:text-sm text-xs z-10">
              {optionList}
            </ul>
          </>
        )}
      </div>
    </>
  );
};

export default Action;
